import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke071aRequest, Sgke071aResponse, Sgke071aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke071aService {

  /**
   * コンストラクタ
   * @param {Sgke071aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke071aService
   */
  constructor(
    private service: Sgke071aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 初期表示API呼び出し
   * @param {Sgke071aRequest} request
   * @return {*}  {Observable<Sgke071aResponse>}
   * @memberof UsedSgke071aService
   */
  public doSgke071a(request: Sgke071aRequest): Observable<Sgke071aResponse> {

    return this.service.ke10RSGKE071APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE071A');
          return throwError(err.message);
        })
      );
  }
}
